
import { Component, Vue, Prop } from 'vue-property-decorator'
import { VNode } from 'vue'
const BLOCK_SELECTOR = 'button-group'
const concat = (...classList: any) => classList.filter(Boolean).join(' ')
@Component
export default class ButtonGroup extends Vue {
    @Prop({ type: Boolean }) collapse!: boolean
    render(createElement: typeof Vue.prototype.$createElement): VNode {
        this.$slots.default?.forEach(vNode => {
            vNode.data = {
                ...vNode.data,
                staticClass: concat(
                    vNode.data && vNode.data.staticClass,
                    `${BLOCK_SELECTOR}__item`,
                    this.collapse && `${BLOCK_SELECTOR}__item--collapse`
                ),
            }
        })

        return createElement(
            'div',
            {
                class: [
                    this.$attrs.class,
                    BLOCK_SELECTOR,
                    {
                        [`${BLOCK_SELECTOR}--collapse`]: this.collapse,
                    },
                ],
            },
            this.$slots.default
        )
    }
}
